import { render } from "./RenameFolder.vue?vue&type=template&id=46873ac2"
import script from "./RenameFolder.vue?vue&type=script&lang=js"
export * from "./RenameFolder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__